import { render, staticRenderFns } from "./MarcomCentral.vue?vue&type=template&id=e2cd9e76&scoped=true&"
import script from "./MarcomCentral.vue?vue&type=script&lang=js&"
export * from "./MarcomCentral.vue?vue&type=script&lang=js&"
import style0 from "./MarcomCentral.vue?vue&type=style&index=0&id=e2cd9e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cd9e76",
  null
  
)

export default component.exports